(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('details[data-dy-auto-open]').forEach((details) => {
      if (details.querySelector('.errors, [role="status"]')) details.open = true;
    });
    scope.querySelectorAll('[data-dy-product]').forEach((product) => {
      if (product.dataset.dyReady) return;
      product.dataset.dyReady = 'true';
      const variantSelect = product.querySelector('[data-dy-variant]');
      const image = product.querySelector('.dy-product__image');
      const plans = product.querySelector('[data-dy-selling-plan]');
      let variants = [], allocations = {};
      try { variants = JSON.parse(product.querySelector('[data-dy-variant-data]').textContent); allocations = JSON.parse(product.querySelector('[data-dy-plan-data]').textContent); } catch (error) { /* Keep native server-rendered form usable. */ }
      const update = (variantChanged) => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const variant = variants.find((item) => String(item.id) === option.value);
        const price = product.querySelector('[data-dy-price]');
        const compare = product.querySelector('[data-dy-compare]');
        const button = product.querySelector('[data-dy-add]');
        let displayPrice = option.dataset.price;
        let displayCompare = option.dataset.compare;
        let planSupported = true;
        if (plans) {
          const availablePlans = allocations[option.value] || [];
          [...plans.options].forEach((planOption) => {
            if (planOption.value) {
              planOption.disabled = !availablePlans.some((allocation) => String(allocation.id) === planOption.value);
              planOption.hidden = planOption.disabled;
            }
          });
          if (!plans.selectedOptions.length || plans.selectedOptions[0].disabled) {
            plans.value = [...plans.options].find((planOption) => !planOption.disabled)?.value ?? '';
          }
          const allocation = availablePlans.find((item) => String(item.id) === plans.value);
          planSupported = plans.value ? Boolean(allocation) : plans.dataset.requiresPlan !== 'true';
          if (allocation) { displayPrice = allocation.price; displayCompare = allocation.compare !== allocation.price ? allocation.compare : ''; }
        }
        price.textContent = displayPrice;
        compare.textContent = displayCompare || '';
        compare.hidden = !displayCompare;
        button.disabled = option.dataset.available !== 'true' || !planSupported;
        button.textContent = option.dataset.available !== 'true' ? '暫時售完' : !planSupported ? '此選項暫不支援購買' : '加入購物車';
        const payment = product.querySelector('.dy-product__payment');
        if (payment) payment.hidden = button.disabled;
        if (variantChanged && variant?.quantity_rule) {
          const quantity = product.querySelector('[data-dy-quantity]');
          quantity.min = variant.quantity_rule.min || 1;
          quantity.step = variant.quantity_rule.increment || 1;
          if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max; else quantity.removeAttribute('max');
          quantity.value = variant.quantity_rule.min || 1;
        }
        if (variantChanged && image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
      };
      variantSelect.addEventListener('change', () => {
        update(true);
        const url = new URL(window.location.href); url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      });
      if (plans) plans.addEventListener('change', () => update(false));
      product.querySelectorAll('[data-dy-image]').forEach((thumbnail) => thumbnail.addEventListener('click', () => {
        if (!image) return; image.src = thumbnail.dataset.dyImage; image.alt = thumbnail.dataset.dyImageAlt || ''; image.removeAttribute('srcset');
      }));
      update(false);
    });
    scope.querySelectorAll('[data-dy-address]').forEach((address) => {
      if (address.dataset.dyReady) return;
      address.dataset.dyReady = 'true';
      const country = address.querySelector('[data-dy-country]');
      const province = address.querySelector('[data-dy-province]');
      const provinceWrap = address.querySelector('[data-dy-province-wrap]');
      if (!country || !province) return;
      if (country.dataset.default) country.value = country.dataset.default;
      const populate = (initial) => {
        let provinces = [];
        try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (error) {}
        province.replaceChildren();
        provinces.forEach(([value, label]) => { const option = document.createElement('option'); option.value = value; option.textContent = label; province.append(option); });
        if (initial && province.dataset.default) province.value = province.dataset.default;
        province.disabled = provinces.length === 0;
        if (provinceWrap) provinceWrap.hidden = provinces.length === 0;
      };
      country.addEventListener('change', () => populate(false)); populate(true);
    });
    scope.querySelectorAll('[data-dy-confirm-delete]').forEach((form) => {
      if (form.dataset.dyReady) return; form.dataset.dyReady = 'true';
      form.addEventListener('submit', (event) => { if (!window.confirm('確定刪除這個地址？')) event.preventDefault(); });
    });
    scope.querySelectorAll('[data-dy-print]').forEach((button) => {
      if (button.dataset.dyReady) return; button.dataset.dyReady = 'true';
      button.addEventListener('click', () => window.print());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
